import { render, staticRenderFns } from "./AttachmentHistory.vue?vue&type=template&id=720e7b9a&"
import script from "./AttachmentHistory.vue?vue&type=script&lang=js&"
export * from "./AttachmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports